module.exports = __webpack_public_path__ + "static/weather-c20e844cbfa54e24ae1fee98d61dc90a.jpg";